import { api } from "./client";

// Certification statuses that a threshold may resolve to. Mirrors the backend
// CertificationStatus enum member names.
//
// Deliberately a SUBSET, not the whole enum: IN_PROCESS is omitted because a
// threshold resolves an assessment to a verdict, and a transient pipeline
// state is not a verdict. This is NOT drift — the omission is pinned by
// backend/tests/unit/test_cert_status_frontend_sync.py, which fails if the
// enum gains a member so the choice has to be made explicitly. Do not
// "helpfully" complete this list; it is a different list from the one in
// utils/certStatus.ts, which does cover every status.
export const CERTIFICATION_STATUSES = [
  "APPROVED",
  "NEEDS_REVIEW",
  "REJECTED",
  "PENDING",
  "REVOKED",
  "RETRACTED",
] as const;

export type CertificationStatusName = (typeof CERTIFICATION_STATUSES)[number];

export type ProbabilityLevel = {
  probability: number;
  status: CertificationStatusName;
  created_at?: string | null;
  updated_at?: string | null;
};

export type ProbabilityLevelInput = {
  probability: number;
  status: CertificationStatusName;
};

export const SettingsApi = {
  listProbabilityLevels() {
    return api
      .get<{ levels: ProbabilityLevel[] }>("/settings/probability-levels")
      .then((r) => r.data.levels);
  },
  replaceProbabilityLevels(levels: ProbabilityLevelInput[]) {
    return api
      .patch<{ levels: ProbabilityLevel[] }>("/settings/probability-levels", { levels })
      .then((r) => r.data.levels);
  },
};
